






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  props: ['letter'],
  computed: {
  capturing() {
  return this.$store.state.capturing;
  }
  }
  })
export default class GameBoardLetter extends Vue {
  @Prop({ default: '' }) letter!: String;
}
